/**
 * Milk yield units (Gareth 2026-08-04): the US dairy industry measures milk
 * by weight in pounds; everyone else the CRM serves works in litres. The
 * database stores litres canonically (farm_sites.average_yield_litres) so
 * reporting stays comparable — US users type and read lbs, and the forms
 * convert at the edge.
 *
 * Conversion uses milk density ~1.03 kg/L: 1 litre ≈ 2.27 lbs.
 */

const LBS_PER_LITRE = 2.27;

export const yieldUsesPounds = (countryCode) =>
  (countryCode || '').toUpperCase() === 'US';

export const yieldUnitLabel = (countryCode) =>
  yieldUsesPounds(countryCode) ? 'lbs' : 'litres';

/** Stored litres -> the number shown in a form input or on a card. */
export const litresToDisplayYield = (litres, countryCode) => {
  if (litres === null || litres === undefined || litres === '') return '';
  const value = Number(litres);
  if (Number.isNaN(value)) return '';
  return yieldUsesPounds(countryCode) ? Math.round(value * LBS_PER_LITRE * 10) / 10 : value;
};

/** Form input value -> litres for the API payload (null when blank). */
export const displayYieldToLitres = (display, countryCode) => {
  if (display === null || display === undefined || display === '') return null;
  const value = Number(display);
  if (Number.isNaN(value)) return null;
  return yieldUsesPounds(countryCode) ? Math.round((value / LBS_PER_LITRE) * 100) / 100 : value;
};

/** "32 litres" / "72.6 lbs" for read-only cards; empty string when unset. */
export const formatYield = (litres, countryCode) => {
  const display = litresToDisplayYield(litres, countryCode);
  if (display === '') return '';
  return `${display} ${yieldUnitLabel(countryCode)}`;
};
